<form [formGroup]="form">
  @if (selectItems(); as selectItems) {
    <app-form-control
      [floatLabel]="true"
      [underlineInputStyle]="true">
      <p-select
        [formControl]="form.controls.sort"
        [options]="selectItems"
        appPrimengSelect
        [fluid]="true"
        placeholder="Domyślne sortowanie" />
    </app-form-control>
  }
</form>
